/**
 * Javascript for loading animations based on Intersection Observer.
 * 
 * @since 1.0.0
 */
export { animationLoader, aniActiveEvent };

const aniActiveEvent = new Event( 'aniActive' );

class animationLoader {
  selector = '.ani';
  ioOptions = {
    root: null,
    rootMargin: '0px 0px 0px 0px',
    threshold: 0.33
  };
  killSwitch = true;
  aniObjects;
  aniObserver;

  
  constructor( selector, ioOptions, killSwitch ){
    if( selector !== undefined ){
      this.selector = selector;
    }
    
    if ( ioOptions !== undefined ) {
      // merge objects using spread syntax
      this.ioOptions = { ...this.ioOptions, ...ioOptions };
    }

    if( killSwitch !== undefined ){
      this.killSwitch = killSwitch;
    }

    this.aniObjects = document.querySelectorAll( this.selector );
    
    if( true === this.killSwitch ){
      this.aniObserver = new IntersectionObserver( this.aniCallbackOnce, this.ioOptions );
    }
    else {
      this.aniObserver = new IntersectionObserver( this.aniCallbackContinuous, this.ioOptions );
    }
    
    window.addEventListener( "load", ( event ) => {
      this.aniObjects.forEach( obj => {
        this.aniObserver.observe( obj );
      } );

    }, false );
  }

  /**
   * Animation callback that stops after one intersection
   * 
   * @param {DOM element} entries 
   * @param {object} observer IntersectionObserver object
   */
  aniCallbackOnce( thisObj, thisObserver ) {
    thisObj.forEach( function ( obj, index ) {

      if ( obj.isIntersecting ) {
        obj.target.classList.add( 'active' );
        obj.target.dispatchEvent( aniActiveEvent );
        thisObserver.unobserve( obj.target );
      }

    } );
  }

  /**
 * Animation callback
 * 
 * @param {DOM element} entries 
 * @param {object} observer IntersectionObserver object
 */
  aniCallbackContinuous( thisObj, thisObserver ) {
    thisObj.forEach( function ( obj, index ) {

      if ( obj.isIntersecting ) {
        obj.target.classList.add( 'active' );
        obj.target.dispatchEvent( aniActiveEvent );
      }
      else {
        obj.target.classList.remove( 'active' );
      }

    } );
  }
}